const GetETypeName = (id) => {
    switch (id) {
        case 1: { return "Emergency" }
        case 0: { return "Normal" }
    }
}

const GetEType = {
    EType: [
        { Id: 0, Name: "Normal" },
        { Id: 1, Name: "Emergency" },
    ]
}

const ETypeBg = (id) => {
    switch (id) {
        case 1: return "bg-red-400"
        case 0: return "bg-green-400"
    }
}

export { GetETypeName, GetEType,ETypeBg }
